module.exports = __webpack_public_path__ + "img/m2-5x3maodingmu.prt.6e432586.jpg";